export default __webpack_public_path__ + "static/media/mukeshJoshi.56e8fedf.jpg";